import { PayloadAction } from '@reduxjs/toolkit';

import { SET_LOADING } from '@/types/store/actions';
import { Loading } from '@/types/store/reducers';

const initialState: Loading = true;

export function loadingReducer(state = initialState, action: PayloadAction<Loading>): Loading {
	switch (action.type) {
		case SET_LOADING:
			return action.payload;
		default:
			return state;
	}
}
